var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "proposal-profile" },
    [
      _vm.isDeliveredForObligation
        ? _c("proposal-PO-info", {
            attrs: { details: _vm.proposalRequestInfo }
          })
        : _vm._e(),
      _c(
        "div",
        [
          _c("section-title", {
            staticClass: "my-4 proposal-profile__section-title",
            attrs: {
              icon: "fas fa-info-circle",
              reverse: "",
              title: "Identificación del Perfil",
              "title-class": "proposal-profile__section-title__info"
            }
          }),
          _c(
            "div",
            { staticClass: "general-info bg-secondary-3 px-4 py-3 rounded" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Tipo de proveedor:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.profile.hiringType))
                  ])
                ]),
                _vm.profile.socialSecurityNo
                  ? _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Número de seguro social patronal:")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(
                          _vm._s(_vm._f("empty")(_vm.profile.socialSecurityNo))
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.profile.isProvisionalRemedyServiceChecked
                  ? _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Servicios a ofrecer:")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.profile.proposalServiceTypeName) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.isSpecialEducationArea
                  ? _c("div", { staticClass: "col-md-6 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " ¿Es usted un proveedor que actualmente tiene contratos con el DE para la provisión de servicios educativos o educativos y terapias?: "
                        )
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.profile.questionYesOrNoProcedure ? "Sí" : "No"
                            ) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.isOmepArea || _vm.isInfrastructureArea
                  ? _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Número de RUL:")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.profile.rulNumber)))
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("section-title", {
            staticClass: "my-4 proposal-profile__section-title",
            attrs: {
              icon: "fas fa-info-circle",
              reverse: "",
              title: "Información General del Proponente",
              "title-class": "proposal-profile__section-title__info"
            }
          }),
          _c(
            "div",
            { staticClass: "general-info bg-secondary-3 px-4 py-3 rounded" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Nombre del proponente:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.profile.corporationName))
                  ])
                ]),
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Correo electrónico:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.profile.proposalEmail))
                  ])
                ]),
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [_vm._v("Teléfono:")]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm._f("phone")(_vm.profile.telephone)))
                  ])
                ]),
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Monto total de la propuesta a someter:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm._f("price")(_vm.profile.proposalAmount)))
                  ])
                ]),
                _vm.isProvisionalRemedyArea
                  ? _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(" Tiempo ofreciendo los servicios propuestos: ")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.profile.serviceOfferTimeAndTerm))
                      ])
                    ])
                  : _vm._e(),
                _vm.isOmepArea || _vm.isInfrastructureArea
                  ? _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Tipo de contratación:")
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm._f("empty")(_vm.profile.hiringType)))
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("section-title", {
            staticClass: "my-4 proposal-profile__section-title",
            attrs: {
              icon: "fas fa-info-circle",
              reverse: "",
              title: "Información del Representante Autorizado",
              "title-class": "proposal-profile__section-title__info"
            }
          }),
          _c(
            "div",
            { staticClass: "general-info bg-secondary-3 px-4 py-3 rounded" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Nombre completo:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.profile.autorizeRepresent))
                  ])
                ]),
                _c("div", { staticClass: "col-md-3 col-12" }, [
                  _c("span", { staticClass: "title" }, [_vm._v("Profesión:")]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("empty")(_vm.profile.representativeProfession)
                        ) +
                        " "
                    )
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("section-title", {
            staticClass: "my-4 proposal-profile__section-title",
            attrs: {
              icon: "fas fa-info-circle",
              reverse: "",
              title: _vm.addressSectionTitle,
              "title-class": "proposal-profile__section-title__info"
            }
          }),
          _c(
            "div",
            { staticClass: "general-info bg-secondary-3 px-4 py-3 rounded" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Dirección Oficina Central:")
                  ]),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.profile.centralOfficeAddress))
                  ])
                ]),
                _vm.isSpecialEducationArea ||
                _vm.isInfrastructureArea ||
                _vm.isOmepArea
                  ? _c("div", { staticClass: "col" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " ¿La corporación, individuo o entidad educativa cuenta con otra oficina central?: "
                        )
                      ]),
                      _c("p", { staticClass: "content" }, [
                        _vm._v(_vm._s(_vm.profile.hasOtherCentralOffice))
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm.isProvisionalRemedyArea
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass: "my-4 proposal-profile__section-title",
                attrs: {
                  icon: "fas fa-info-circle",
                  reverse: "",
                  title: "Areas Geográficas",
                  "title-class": "proposal-profile__section-title__info"
                }
              }),
              _vm.geographyAreaMunicipalities.length == 0
                ? _c("result-not-found")
                : _vm._e(),
              _vm.geographyAreaMunicipalities.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "general-info bg-secondary-3 px-4 py-3 rounded"
                    },
                    _vm._l(_vm.geographyAreaMunicipalities, function(
                      municipality
                    ) {
                      return _c(
                        "span",
                        {
                          key: municipality.id,
                          staticClass:
                            "badge badge-pill font-16 color-black mr-2 mb-2 badge-chip"
                        },
                        [_vm._v(" " + _vm._s(municipality.name) + " ")]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.isProvisionalRemedyArea || _vm.isSpecialEducationArea
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass: "my-4 proposal-profile__section-title",
                attrs: {
                  icon: "fas fa-info-circle",
                  reverse: "",
                  title: "Datos de Servicio a Ofrecer",
                  "title-class": "proposal-profile__section-title__info"
                }
              }),
              _vm.offeringServices.length == 0
                ? _c("result-not-found")
                : _vm._e(),
              _vm.offeringServices.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "general-info bg-secondary-3 px-4 py-3 rounded"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.groupedOfferingServices, function(
                          services,
                          label
                        ) {
                          return _c(
                            "div",
                            {
                              key: label,
                              staticClass: "col col-sm col-12 mb-3"
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "color-gray-6 mb-2 font-14" },
                                [_vm._v(_vm._s(label))]
                              ),
                              _vm._l(services, function(service) {
                                return _c(
                                  "span",
                                  {
                                    key: service.disciplineTypeId,
                                    staticClass:
                                      "badge badge-pill font-16 color-black mr-2 mb-2 badge-chip"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(service.disciplineTypeName) +
                                        " "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }